import { useContext } from "react";
import { RestClient } from "../classes/RestClient";
import { RestContext } from "../components/RestProvider";

export function useRestClient<TEndPoints>(): RestClient<TEndPoints> {
  const client = useContext(RestContext);
  return client as RestClient<TEndPoints>;
}